import { TestsheetListingItem } from "@services/index";

export const TestsheetLabelProvider = ({ testsheet }: { testsheet: TestsheetListingItem }) => {
    if(testsheet?.building_id) {
        return `${testsheet.worksite} - Bât. ${testsheet.batiment}`;
    }

    if(testsheet?.apartment_id.includes('|')) {
        return `${testsheet.worksite} - Apt. n°${testsheet.apartment_id.split('|').join(', ')}`;
    }

    return `${testsheet.worksite} - Apt. n°${testsheet.apartment_id}`;
};
